import { useQuery } from '@tanstack/react-query'
import { apiClient } from '../lib/api'
import type { OneCStockResponse } from '../types/onec-stock.types'

const ONEC_STOCK_QUERY_KEY = 'onec-stock'

/**
 * Остатки медикаментов из 1С в реальном времени.
 * Если warehouseId не задан — берётся склад текущего сотрудника (бэкенд).
 */
export const useOneCStock = (warehouseId?: string) => {
  return useQuery({
    queryKey: [ONEC_STOCK_QUERY_KEY, warehouseId ?? 'me'],
    queryFn: async (): Promise<OneCStockResponse> =>
      apiClient.getOneCStock(warehouseId),
    staleTime: 30 * 1000,
    retry: 1,
  })
}
